import { useHttp } from '../http'

export const usePremiumHttp = () => {

    const getPersonalizedPlans = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/personalized-plans`, payload)
    }

    const exportPersonalizedPlans = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/personalized-plans/export`, payload, { responseType: 'blob' })
    }

    const getOneMonthTrials = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/one-month-trials`, payload)
    }

    const exportOneMonthTrials = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/one-month-trials/export`, payload, { responseType: 'blob' })
    }

    const getLifetimeUsers = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/lifetime-users`, payload)
    }

    const exportLifetimeUsers = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/lifetime-users/export`, payload, { responseType: 'blob' })
    }

    const getUserFeedbacks = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/user-feedbacks`, payload)
    }

    const exportUserFeedbacks = <T>(payload: any): Promise<T> => {
        return useHttp().get(`premium/user-feedbacks/export`, payload, { responseType: 'blob' })
    }

    return {
        getPersonalizedPlans,
        exportPersonalizedPlans,
        getOneMonthTrials,
        exportOneMonthTrials,
        getLifetimeUsers,
        exportLifetimeUsers,
        getUserFeedbacks,
        exportUserFeedbacks,
    }
}
